module.exports = ".btn-group .btn{\r\n    min-width: 5px;\r\n}\r\n.btn-group i{  \r\n    color: white;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/sales-orders/sales-quotation/salse-quotation-form/salse-quotation-form.component.css
// module id = ./src/app/Pages/sales-orders/sales-quotation/salse-quotation-form/salse-quotation-form.component.css
// module chunks = main